import {FormControl, FormGroup} from "@angular/forms";
import {AreaForm} from "./area.form";
import {SimpleNotificationPreference} from "../../../openapi";
import {NotificationFormData} from "../../../services/my-settings.common.service";

export class NotificationTopicForm extends FormGroup {
  constructor() {
    super({
      sms: new FormControl(false),
      email: new FormControl(false),
      push: new FormControl(false)
    });
  }

  public get sms(): FormControl {
    return this.get('sms') as FormControl;
  }

  public get email(): FormControl {
    return this.get('email') as FormControl;
  }

  public get push(): FormControl {
    return this.get('push') as FormControl;
  }
}

export class NotificationForm extends FormGroup {

  public topics: string[] = [];

  constructor() {
    super({});
  }

  public getItemForm(topic: string): NotificationTopicForm {
    return this.get(topic) as NotificationTopicForm;
  }

  public get areaForm(): AreaForm {
    return this.get('areaForm') as AreaForm;
  }

  public initForm(data: NotificationFormData): NotificationForm {
    data.topics.forEach((topic) => {
      const f = new NotificationTopicForm();
      const channels: string[] = data.preferences.filter(v => v?.topic === topic).map(v => v?.channel || '');
      f.patchValue({
        sms: channels.includes('sms'),
        email: channels.includes('email'),
        push: channels.includes('push')
      })
      this.addControl(topic, f);
    });
    this.topics = data.topics;

    this.addControl('areaForm', new AreaForm().initForm(data));
    return this;
  }

  public get preferenceValues(): SimpleNotificationPreference[] {
    const result: SimpleNotificationPreference[] = [];
    this.topics
      .forEach(name => {
        const itemForm: NotificationTopicForm = this.get(name) as NotificationTopicForm;
        if (itemForm.sms.value) {
          result.push({
            topic: name,
            channel: 'sms'
          });
        }
        if (itemForm.email.value) {
          result.push({
            topic: name,
            channel: 'email'
          });
        }
        if (itemForm.push.value) {
          result.push({
            topic: name,
            channel: 'push'
          });
        }
      });
    return result;
  }

  public get subscribedAreaValues(): string[] {
    return this.areaForm.toWriteModel();
  }

}
